// src/components/TechTag.jsx
import React from "react";
import { Box } from "@mui/material";

const TechTag = ({ icon, label }) => (
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 0.5,
      px: 1,
      py: 0.5,
      borderRadius: 999,
      bgcolor: "grey.100",
      fontSize: 12,
      mr: 0.5,
      mt: 0.5,
    }}
  >
    {icon}
    {label}
  </Box>
);

export default TechTag;
